// extracted by mini-css-extract-plugin
export default {"flexHack":"NNCd69I"};